import React, {useState, useEffect} from 'react'

import BrassPanel from '../../../components/BrassPanel'


function MachineSliders({setPlayerInput, resetGame}) {
    const [sliderInput, setSliderInput] = useState(['y', 'y'])
    const [sliderValue, setSliderValue] = useState([0, 0])
    
    function handleSliderChange(event) {
        const {value, name} = event.target
        const newTrueArr = [...sliderInput]
        const newValueArr = [...sliderValue]
        const trueValue = ['y', 'b', 'x', 'a']
        
        newValueArr[name] = value
        setSliderValue(newValueArr)
        
        newTrueArr[name] = trueValue[value]
        setSliderInput(newTrueArr)
        updatePlayerInput(newTrueArr)
    }
    
    function updatePlayerInput(newArr) {
        setPlayerInput(prevInput => {
            return ({
                ...prevInput,
                sliders: newArr.join('')
            })
        })
    }
    
    function setUpSliders() {
        const sliderCode = []
        for (let i=0; i < 2; i++) {
            const sliderSide = i === 0 ? 'left' : 'right'
            sliderCode.push(                
                <input
                    key={i}
                    type='range'
                    className={`machine_rangeSlider machine_rangeSlider-${sliderSide}`}
                    min='0'
                    max='3'
                    name={i}
                    value={sliderValue[i]}
                    onChange={handleSliderChange}
                />
            )
        }
        return sliderCode
    }
    
    useEffect(() => {
        if (resetGame) {
            const resetInputArr = ['y', 'y']
            setSliderValue([0, 0])
            setSliderInput(resetInputArr)
            updatePlayerInput(resetInputArr)
        } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetGame])
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-rangeSliders'>
            {setUpSliders()}
            <div className='rangeSlider_scaleContainer'>
                <p>A</p>
                <p>X</p>
                <p>B</p>
                <p>Y</p>
            </div>
        </BrassPanel>
    )
}

export default MachineSliders